import { AppUpdate } from '@/types/updates';
import { update_2025_08 } from './2025-08-foundation';
import { update_2025_09 } from './2025-09-interaction';
import { update_2025_10 } from './2025-10-escape-mode';
import { update_2025_11 } from './2025-11-studio-ux';
import { update_2025_12 } from './2025-12-vfx-blasts';
import { update_2026_01 } from './2026-01-multi-sim';
import { update_2026_02 } from './2026-02-performance';
import { update_2026_03 } from './2026-03-visual-depth';
import { update_2026_04 } from './2026-04-audio-synthesis';
import { update_2026_05 } from './2026-05-beta-launch';

export const UPDATES: AppUpdate[] = [
  update_2026_05,
  update_2026_04,
  update_2026_03,
  update_2026_02,
  update_2026_01,
  update_2025_12,
  update_2025_11,
  update_2025_10,
  update_2025_09,
  update_2025_08,
];
